import React from 'react';
import ValutaFilter from '@eika-infrastruktur/ui-valuta-filter';

interface ResultatBoksProps {
    header: string;
    colorSwitch: boolean;
    forventetBelopText: string;
    forventetBelop: number;
    totaltInnskuddText: string;
    totaltInnskudd: number;
}

const ResultatBoks = (props: ResultatBoksProps) => {
    return (
        <div className={`result-box ${props.colorSwitch ? 'primary-color' : 'secondary-color'}`}>
            <div className="result-box-header">{props.header}</div>
            <div className="sub-header"> {props.forventetBelopText} </div>
            <div>
                <div className="primary-amount">{ValutaFilter(props.forventetBelop, ' ', 0)}</div>
                <span className="primary-suffix"> kr</span>
            </div>
            <div className="sub-header">{props.totaltInnskuddText}</div>
            <div className="secondary-amount">{ValutaFilter(props.totaltInnskudd, ' ', 0)}</div>
            <span className="secondary-suffix"> kr</span>
        </div>
    );
};

export default ResultatBoks;
